<mat-icon
  [style.background]="color"
  class="tag-ico"
  >{{tag?.icon}}</mat-icon
>
<span class="tag-title">{{tag?.title}}</span>
